export default {
    apiKey: "AIzaSyAtqOtLN1kVjgcEPZ2vg1zL-tPzVJBbCp0",
    authDomain: "molecule-teaser.firebaseapp.com",
    databaseURL: "https://molecule-teaser.firebaseio.com",
    projectId: "molecule-teaser",
    storageBucket: "molecule-teaser.appspot.com",
    messagingSenderId: "193610939143"
}